import {Component, OnInit} from '@angular/core';
import { properties } from 'src/environments/properties';

@Component({
    selector: 'app-freshpass-title',
    templateUrl: './freshpass-title.component.html',
    styleUrls: ['./freshpass-title.component.scss']
})
export class FreshpassTitleComponent implements OnInit {

    showSmallTitle: boolean;
    properties = properties;

    enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
    programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

    ngOnInit(): void {
        if (window.screen.width < 990) {
            this.showSmallTitle = true;
        } else {
            this.showSmallTitle = false;
        }
    }

}
